<template>
  <div class="goodList">
    <div
      class="goodItem flexContainer"
      v-for="data in list"
      :key="data.id"
      @click="goDetail(data)"
    >
      <div class="flexItem1 goodItemImg">
        <img
          src="https://dimg04.c-ctrip.com/images/0201h120005u5p9ylED32_C_400_600_R5_Q70.jpg_.webp?v=1"
        />
        <div class="imgTip textellipsis">
          <i class="iconfont_new icon-huo"></i>星级人气榜
        </div>
      </div>
      <div class="flexItem2 goodItemText">
        <div class="title">{{data.name}}</div>
        <div class="titleIcon">
          <i class="iconfont_new icon-zhuanshi1 zuanshi" v-for="(item,key) in data.star" :key="key"></i>
        </div>
        <div class="fraction">
          <span>4.9</span>分  <i class="iconfont_new icon-tubiao303 redColor"></i>
        </div>
        <div class="position">{{data.position}}</div>

        <div class="flexContainer">
          <div class="flexItem1 goodItemAllTag" style="padding: 0.2rem 0 0;">
            <span class="goodItemTag" v-for="(item,key) in data.tag" :key="key">{{item.value}}</span>
          </div>
          <div class>
            <div class="flight-number">
              <dfn>¥</dfn>
              <strong>{{data.price}}</strong>
              <dfn>起</dfn>
            </div>
          </div>
        </div>
        <div class="warning">{{data.warning}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "goodList",
  props: {
    list: {
      type: Array,
      default: [],
      required: false,
    },
    detailPage: {
      type: String,
      default: "",
      required: false,
    },
  },
  data() {
    return {};
  },
  components: {},
  activated: function () {},
  created() {},
  mounted() {},
  methods: {
    goDetail(data) {
      let that = this;
      this.$router.push({
        name: that.detailPage,
      });
    },
  },
};
</script>

<style scoped lang="less">
@import "../../style/home.less";
</style>



// WEBPACK FOOTER //
// src/components/child-components/goodItem.vue